function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.573 0l-3.437 3.5 8.838 9H0v5h21.974l-8.838 9 3.437 3.5 14.731-15z",
  fill: "param(fill) #FFFFFF",
  fillRule: "evenodd"
});
function SvgChevronCompareRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgChevronCompareRight;